export const getEditableElementsSelector = (editableElements: string[], ignoreClass?: string) => {
  return editableElements
    .map(element => `${element}[e-editable]`)
    .map(selector => {
      if (!ignoreClass) return selector;
      return `${selector}:not(.${ignoreClass})`;
    })
    .join(', ');
};
